import { HolidaysCreateLoading } from '@/pages/time-off-holidays/admin-create/holidays-create.loading';

export default HolidaysCreateLoading;
